var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: _vm.$t("SeaExport.ServiceInformation"),
        visible: _vm.dialogShow,
        no: "1",
        width: "900px"
      },
      on: {
        "update:visible": function($event) {
          _vm.dialogShow = $event
        }
      }
    },
    [
      _c(
        "div",
        [
          _c(
            "el-tabs",
            {
              attrs: { no: "2", type: "card" },
              on: { "tab-click": _vm.handleClick },
              model: {
                value: _vm.activeName,
                callback: function($$v) {
                  _vm.activeName = $$v
                },
                expression: "activeName"
              }
            },
            [
              _c(
                "el-tab-pane",
                {
                  attrs: {
                    no: "3",
                    label: _vm.$t("SeaExport.ScopeServices"),
                    name: "ScopeServices"
                  }
                },
                [
                  _c(
                    "div",
                    [
                      _c(
                        "el-button-group",
                        [
                          _c(
                            "el-button",
                            {
                              class: { selected: _vm.isSh },
                              attrs: { no: "4" },
                              on: {
                                click: function($event) {
                                  return _vm.selectTab(true)
                                }
                              }
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t("OperationGuide.ShanghaiPort")
                                  ) +
                                  " "
                              )
                            ]
                          ),
                          _c(
                            "el-button",
                            {
                              class: { selected: !_vm.isSh },
                              attrs: { no: "5" },
                              on: {
                                click: function($event) {
                                  return _vm.selectTab(false)
                                }
                              }
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.$t("OperationGuide.QingdaoPort")) +
                                  " "
                              )
                            ]
                          )
                        ],
                        1
                      ),
                      _c("div", { staticStyle: { height: "20px" } })
                    ],
                    1
                  ),
                  _c("div", { staticClass: "text1", attrs: { no: "6" } }, [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.$t("OperationGuide.Text1") +
                            _vm.shippingCompanyList.length +
                            _vm.$t("OperationGuide.Text2") +
                            _vm.carrierAgentList.length +
                            _vm.$t("OperationGuide.Text3")
                        )
                    )
                  ]),
                  _c("div", { staticStyle: { height: "15px" } }),
                  _c("div", { staticClass: "h-px", attrs: { no: "7" } }),
                  _c(
                    "div",
                    { staticClass: "service-coverage", attrs: { no: "8" } },
                    [
                      _c("p", { staticClass: "title1", attrs: { no: "9" } }, [
                        _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_CarrierShip")))
                      ]),
                      _c(
                        "div",
                        { staticClass: "container", attrs: { no: "10" } },
                        _vm._l(_vm.shippingCompanyList, function(item) {
                          return _c(
                            "button",
                            { key: item.uuid, staticClass: "button" },
                            [_vm._v(_vm._s(item.name))]
                          )
                        }),
                        0
                      ),
                      _c("p", { staticClass: "title1", attrs: { no: "11" } }, [
                        _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_CarrierAgent")))
                      ]),
                      _c(
                        "div",
                        { staticClass: "container", attrs: { no: "12" } },
                        _vm._l(_vm.carrierAgentList, function(item) {
                          return _c(
                            "button",
                            { key: item.uuid, staticClass: "button" },
                            [_vm._v(_vm._s(item.name))]
                          )
                        }),
                        0
                      ),
                      _c("p", { staticClass: "title1" }, [
                        _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Remarks")))
                      ]),
                      _c("div", [
                        _c("div", [
                          _c("span", { staticClass: "remarks" }, [
                            _vm._v(_vm._s(_vm.$t("OperationGuide.Remark1")))
                          ]),
                          _c("span", { staticClass: "remarks2" }, [
                            _vm._v(_vm._s(_vm.$t("OperationGuide.Remark2")))
                          ])
                        ]),
                        _c("div", [
                          _c("span", { staticClass: "remarks" }, [
                            _vm._v(_vm._s(_vm.$t("OperationGuide.Remark3")))
                          ]),
                          _c("span", { staticClass: "remarks2" }, [
                            _vm._v(_vm._s(_vm.$t("OperationGuide.Remark4")))
                          ])
                        ]),
                        _c("div", [
                          _c("span", { staticClass: "remarks" }, [
                            _vm._v(_vm._s(_vm.$t("OperationGuide.Remark5")))
                          ]),
                          _c("span", { staticClass: "remarks2" }, [
                            _vm._v(_vm._s(_vm.$t("OperationGuide.Remark6")))
                          ])
                        ]),
                        _c("div", [
                          _c("span", { staticClass: "remarks" }, [
                            _vm._v(_vm._s(_vm.$t("OperationGuide.Remark7")))
                          ]),
                          _c("span", { staticClass: "remarks2" }, [
                            _vm._v(_vm._s(_vm.$t("OperationGuide.Remark8")))
                          ])
                        ]),
                        _c("div", [
                          _c("span", { staticClass: "remarks" }, [
                            _vm._v(_vm._s(_vm.$t("OperationGuide.Remark9")))
                          ]),
                          _c("span", { staticClass: "remarks2" }, [
                            _vm._v(_vm._s(_vm.$t("OperationGuide.Remark10")))
                          ])
                        ]),
                        _c("div", [
                          _c("span", { staticClass: "remarks" }, [
                            _vm._v(_vm._s(_vm.$t("OperationGuide.Remark11")))
                          ]),
                          _c("span", { staticClass: "remarks2" }, [
                            _vm._v(_vm._s(_vm.$t("OperationGuide.Remark12")))
                          ])
                        ]),
                        _c("div", [
                          _c("span", { staticClass: "remarks" }, [
                            _vm._v(_vm._s(_vm.$t("OperationGuide.Remark13")))
                          ]),
                          _c("span", { staticClass: "remarks2" }, [
                            _vm._v(_vm._s(_vm.$t("OperationGuide.Remark14")))
                          ])
                        ]),
                        _c("div", [
                          _c("span", { staticClass: "remarks" }, [
                            _vm._v(_vm._s(_vm.$t("OperationGuide.Remark15")))
                          ]),
                          _c("span", { staticClass: "remarks2" }, [
                            _vm._v(_vm._s(_vm.$t("OperationGuide.Remark16")))
                          ])
                        ])
                      ])
                    ]
                  )
                ]
              ),
              _c(
                "el-tab-pane",
                {
                  attrs: {
                    no: "13",
                    label: _vm.$t("SeaExport.DeletionGuide"),
                    name: "DeletionGuide"
                  }
                },
                [
                  _c("div", { staticClass: "text1" }, [
                    _vm._v(_vm._s(_vm.$t("OperationGuide.DeletionGuide")))
                  ]),
                  _c("div", { staticStyle: { height: "15px" } }),
                  _c("div", { staticClass: "h-px" }),
                  _c("h4", { staticClass: "title2" }, [
                    _vm._v(_vm._s(_vm.$t("OperationGuide.Text4")))
                  ]),
                  _c("p", { staticClass: "sub-title" }, [
                    _vm._v(_vm._s(_vm.$t("OperationGuide.Remark17")))
                  ]),
                  _c("div", { staticClass: "text2" }, [
                    _c("span", [
                      _vm._v(_vm._s(_vm.$t("OperationGuide.Remark18")))
                    ]),
                    _c("span", [
                      _vm._v(_vm._s(_vm.$t("OperationGuide.Remark19")))
                    ]),
                    _c("span", [
                      _vm._v(_vm._s(_vm.$t("OperationGuide.Remark20")))
                    ]),
                    _c(
                      "div",
                      {
                        staticStyle: {
                          "text-indent": "2em",
                          "flex-direction": "column",
                          display: "flex"
                        }
                      },
                      [
                        _c("span", [
                          _vm._v(_vm._s(_vm.$t("OperationGuide.Remark21")))
                        ]),
                        _c("span", [
                          _vm._v(_vm._s(_vm.$t("OperationGuide.Remark22")))
                        ]),
                        _c("span", [
                          _vm._v(_vm._s(_vm.$t("OperationGuide.Remark23")))
                        ])
                      ]
                    )
                  ]),
                  _c("p", { staticClass: "sub-title" }, [
                    _vm._v(_vm._s(_vm.$t("OperationGuide.Remark24")))
                  ]),
                  _c("div", { staticClass: "text2" }, [
                    _c("span", [
                      _vm._v(_vm._s(_vm.$t("OperationGuide.Remark25")))
                    ]),
                    _c("span", [
                      _vm._v(_vm._s(_vm.$t("OperationGuide.Remark26")))
                    ]),
                    _c("span", [
                      _vm._v(_vm._s(_vm.$t("OperationGuide.Remark27")))
                    ])
                  ]),
                  _c("p", { staticClass: "sub-title" }, [
                    _vm._v(_vm._s(_vm.$t("OperationGuide.Remark28")))
                  ]),
                  _c("div", { staticClass: "text2" }, [
                    _c("span", [
                      _vm._v(_vm._s(_vm.$t("OperationGuide.Remark29")))
                    ]),
                    _c("span", [
                      _vm._v(_vm._s(_vm.$t("OperationGuide.Remark30")))
                    ])
                  ]),
                  _c("h4", { staticClass: "title2" }, [
                    _vm._v(_vm._s(_vm.$t("OperationGuide.Remark31")))
                  ]),
                  [
                    _c(
                      "div",
                      { staticClass: "container" },
                      [
                        _c(
                          "el-table",
                          {
                            staticClass: "pro-table",
                            attrs: {
                              data: _vm.companyList,
                              border: "",
                              fit: "",
                              stripe: "",
                              no: "14",
                              size: "small"
                            }
                          },
                          [
                            _c("el-table-column", {
                              attrs: {
                                prop: "name",
                                label: _vm.$t("OperationGuide.CarrierName"),
                                align: "center",
                                width: "250",
                                no: "15"
                              }
                            }),
                            _c("el-table-column", {
                              attrs: {
                                prop: "address",
                                label: _vm.$t("SeaExport.Address"),
                                align: "center",
                                width: "588",
                                no: "16"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]
                ],
                2
              ),
              _c(
                "el-tab-pane",
                {
                  attrs: {
                    no: "17",
                    label: _vm.$t("SeaExport.BusinessData"),
                    name: "BusinessData"
                  }
                },
                [
                  _c("div", { staticClass: "text1" }, [
                    _vm._v(_vm._s(_vm.$t("OperationGuide.BusinessData")))
                  ]),
                  _c("div", { staticStyle: { height: "15px" } }),
                  _c("div", { staticClass: "h-px" }),
                  _c("div", { staticStyle: { height: "15px" } }),
                  [
                    _c(
                      "div",
                      [
                        _c(
                          "div",
                          { staticClass: "filter-container" },
                          [
                            _c(
                              "el-select",
                              {
                                attrs: {
                                  no: "18",
                                  placeholder: _vm.$t(
                                    "CargoMsg.Cargo_BusinessType"
                                  )
                                },
                                model: {
                                  value: _vm.selectedType,
                                  callback: function($$v) {
                                    _vm.selectedType = $$v
                                  },
                                  expression: "selectedType"
                                }
                              },
                              _vm._l(_vm.businessTypes, function(item) {
                                return _c("el-option", {
                                  key: item.value,
                                  attrs: {
                                    label: item.label,
                                    value: item.value
                                  }
                                })
                              }),
                              1
                            ),
                            _c(
                              "el-select",
                              {
                                attrs: {
                                  no: "19",
                                  placeholder: _vm.$t(
                                    "CargoMsg.Cargo_CarrierAgent"
                                  )
                                },
                                model: {
                                  value: _vm.selectedAgent,
                                  callback: function($$v) {
                                    _vm.selectedAgent = $$v
                                  },
                                  expression: "selectedAgent"
                                }
                              },
                              _vm._l(_vm.agents, function(item) {
                                return _c("el-option", {
                                  key: item.value,
                                  attrs: {
                                    label: item.label,
                                    value: item.value
                                  }
                                })
                              }),
                              1
                            )
                          ],
                          1
                        ),
                        _c(
                          "el-table",
                          {
                            staticClass: "pro-table",
                            attrs: {
                              data: _vm.paginatedData,
                              border: "",
                              fit: "",
                              stripe: "",
                              no: "20",
                              size: "small"
                            }
                          },
                          [
                            _c("el-table-column", {
                              attrs: {
                                prop: "type",
                                label: _vm.$t("CargoMsg.Cargo_BusinessType"),
                                align: "center",
                                width: "200",
                                no: "21"
                              }
                            }),
                            _c("el-table-column", {
                              attrs: {
                                prop: "agent",
                                label: _vm.$t("CargoMsg.Cargo_CarrierAgent"),
                                align: "center",
                                width: "189",
                                no: "22"
                              }
                            }),
                            _c("el-table-column", {
                              attrs: {
                                prop: "fileName",
                                label: _vm.$t("CargoMsg.Cargo_FileName"),
                                align: "center",
                                width: "350",
                                no: "23"
                              }
                            }),
                            _c("el-table-column", {
                              attrs: {
                                label: _vm.$t("CargoMsg.Cargo_Operation"),
                                align: "center",
                                width: "100",
                                no: "24"
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "default",
                                  fn: function(scope) {
                                    return [
                                      _c(
                                        "el-button",
                                        {
                                          attrs: {
                                            no: "25",
                                            type: "text",
                                            size: "small"
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.handleDownload(
                                                scope.row
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("CargoMsg.Cargo_Download")
                                            )
                                          )
                                        ]
                                      )
                                    ]
                                  }
                                }
                              ])
                            })
                          ],
                          1
                        ),
                        _c("el-pagination", {
                          attrs: {
                            background: "",
                            layout: "prev, pager, next",
                            total: _vm.filteredData.length,
                            "page-size": _vm.pageSize,
                            no: "26"
                          },
                          on: { "current-change": _vm.handlePageChange }
                        })
                      ],
                      1
                    )
                  ]
                ],
                2
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c(
            "el-button",
            {
              attrs: { no: "27" },
              on: {
                click: function($event) {
                  _vm.dialogShow = false
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("SeaExport.Close")))]
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }